import {
  ADD_TO_CART, REMOVE_FROM_CART, CLEAR_CART
} from "../constants";

const initialState = [
  // {
  //   "category_id": 1,
  //   "cost": "323",
  //   "icon": "http://storage.mobelpost.rexit.info/cache/1/TFTrJa9r5ZjfqGj7UqvLi9_YfT9UEfTb.png?s=2c4dbedf0e33409fe69dfb0598551d98",
  //   "id": 1,
  //   "installation": true,
  //   "name": "Chair",
  //   "quantity": "23",
  //   "randomId": "1569939485806.679",
  //   "should_enter_price": true,
  //   "should_enter_size": false,
  //   "bringInWindow": true
  // }
]

export default (state = initialState, action) => {
  const {type, payload, randomId} = action;
  switch (type) {
    case ADD_TO_CART:
      return [...state, {...payload.product, randomId}];

    case REMOVE_FROM_CART:
      return state.filter(el => el.randomId !== payload.idProduct)

    case CLEAR_CART:
      return state = [];

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/cart.js